import { AutogenModelRevenueCodeMulticompany, AutogenRowRevenueCodeMulticompany } from "./autogen/AutogenModelRevenueCodeMulticompany";

export class ModelRevenueCodeMulticompany extends AutogenModelRevenueCodeMulticompany<RowRevenueCodeMulticompany> {
	constructor() {
		super(RowRevenueCodeMulticompany);
	}
}

export class RowRevenueCodeMulticompany extends AutogenRowRevenueCodeMulticompany {
}